(function () {
  'use strict';

  var activeDialog = null;
  var previousFocus = null;
  var chartCache = new WeakMap();

  function cleanText(value) {
    var holder = document.createElement('div');
    holder.innerHTML = String(value || '');
    return (holder.textContent || '').trim();
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    dialog.hidden = true;
    document.body.classList.remove('native-size-chart-open');
    activeDialog = null;
    if (previousFocus) previousFocus.focus();
  }

  function createTable(tableData) {
    var wrapper = document.createElement('div');
    wrapper.className = 'native-size-chart__table-wrap';
    var table = document.createElement('table');
    table.className = 'native-size-chart__table';
    var rows = tableData && Array.isArray(tableData.data) ? tableData.data : [];

    rows.forEach(function (row, rowIndex) {
      var tr = document.createElement('tr');
      row.forEach(function (cell, cellIndex) {
        var tag = rowIndex === 0 || cellIndex === 0 || cell.type === 'header' ? 'th' : 'td';
        var node = document.createElement(tag);
        if (tag === 'th') node.scope = rowIndex === 0 ? 'col' : 'row';
        var value = cleanText(cell.value);
        if (cell.unitType && cell.unitType !== 'string' && value && !/[a-z%]/i.test(value)) {
          value += ' ' + cell.unitType;
        }
        node.textContent = value;
        tr.appendChild(node);
      });
      table.appendChild(tr);
    });
    wrapper.appendChild(table);
    return wrapper;
  }

  function renderSizing(container, sizing) {
    var layout = sizing.layout && Array.isArray(sizing.layout.data) ? sizing.layout.data : [];
    var renderedTable = false;

    layout.forEach(function (block) {
      if (block.type === 1 && sizing.tables && sizing.tables[block.value]) {
        container.appendChild(createTable(sizing.tables[block.value]));
        renderedTable = true;
      } else if (block.type === 0 && cleanText(block.value)) {
        var text = document.createElement('p');
        text.className = 'native-size-chart__note';
        text.textContent = cleanText(block.value);
        container.appendChild(text);
      } else if (block.type === 6 && block.data && block.data.url) {
        var url = String(block.data.url);
        if (/^(https?:)?\/\//.test(url)) {
          var image = document.createElement('img');
          image.className = 'native-size-chart__image';
          image.src = url;
          image.alt = '';
          image.loading = 'lazy';
          container.appendChild(image);
        }
      }
    });

    if (!renderedTable && sizing.tables) {
      Object.keys(sizing.tables).forEach(function (key) {
        container.appendChild(createTable(sizing.tables[key]));
      });
    }
  }

  function renderPayload(dialog, payload) {
    var content = dialog.querySelector('[data-native-size-chart-content]');
    content.textContent = '';
    var sizings = payload && Array.isArray(payload.sizings) ? payload.sizings : [];

    sizings.forEach(function (sizing, index) {
      var panel = document.createElement('section');
      panel.className = 'native-size-chart__panel';
      if (sizings.length > 1) {
        var heading = document.createElement('h3');
        heading.textContent = cleanText(sizing.name) || ('Chart ' + (index + 1));
        panel.appendChild(heading);
      }
      renderSizing(panel, sizing);
      content.appendChild(panel);
    });
  }

  async function openChart(button) {
    var dialog = button.closest('[data-native-size-chart-root]').querySelector('[data-native-size-chart-dialog]');
    var content = dialog.querySelector('[data-native-size-chart-content]');
    previousFocus = button;
    activeDialog = dialog;
    dialog.hidden = false;
    document.body.classList.add('native-size-chart-open');
    dialog.querySelector('[data-native-size-chart-close]').focus();

    if (dialog.dataset.loaded === 'true') return;
    if (chartCache.has(button)) {
      renderPayload(dialog, chartCache.get(button));
      dialog.dataset.loaded = 'true';
      return;
    }
    content.textContent = button.dataset.loadingLabel || 'Loading…';
    try {
      var response = await fetch(button.dataset.chartUrl, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Size chart unavailable');
      var payload = await response.json();
      if (!payload.sizings || !payload.sizings.length) throw new Error('Size chart unavailable');
      renderPayload(dialog, payload);
      dialog.dataset.loaded = 'true';
    } catch (error) {
      content.textContent = button.dataset.errorLabel || 'Size chart is temporarily unavailable.';
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-native-size-chart-open]');
    if (opener) {
      event.preventDefault();
      openChart(opener);
      return;
    }
    if (event.target.closest('[data-native-size-chart-close]')) closeDialog(activeDialog);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && activeDialog) closeDialog(activeDialog);
  });

  function prepareButton(button) {
    fetch(button.dataset.chartUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('No chart');
        return response.json();
      })
      .then(function (payload) {
        if (!payload.sizings || !payload.sizings.length) throw new Error('No chart');
        chartCache.set(button, payload);
        button.hidden = false;
      })
      .catch(function () {
        button.remove();
      });
  }

  document.querySelectorAll('[data-native-size-chart-open]').forEach(prepareButton);
})();
